module.exports = __webpack_public_path__ + "img/group_travel_insurance.66b543f7.webp";